import clsx from "clsx"
import { FC } from "react"
import { Button, IButton } from "ui/@button"
import { arrowGoBackIcon } from "assets/icons"
import "./index.scss"

export interface ButtonRingProps extends IButton {
  icon?: string
}

export const ButtonRing: FC<ButtonRingProps> = ({
  icon,

  className,
  ...props
}) => {
  return (
    <Button
      id="button-ring"
      className={clsx(`button-ring`, className)}
      triangleTopPosLeft="40%"
      triangleBottomPosLeft="none"
      {...props}
    >
      <img src={icon || arrowGoBackIcon} alt="go back" />
    </Button>
  )
}
